/*
 *  Class MobileMenu
 */
export
default class MobileMenu {
    constructor() {
        this.menuBtnToggle = document.querySelector('.js-mobile-menu-btn');
        // this.menuBtnClose = document.querySelector('.mobile-menu__close')
        this.body = document.body;
    }

    showMenu(e) {
        e.preventDefault();
        this.body.classList.add('js-mobile-menu--visible');
        this.menuBtnToggle.classList.add('is-active');
    }

    hideMenu(e) {
        e.preventDefault();
        this.body.classList.remove('js-mobile-menu--visible');
        this.menuBtnToggle.classList.remove('is-active');
        
        // hide all submenus
        const allOpenSubmenus = document.querySelectorAll('.header-mobile-submenu.open');
        if (allOpenSubmenus.length) {
            for (let submenu of allOpenSubmenus) {
                submenu.classList.remove('open');
            }
        }
    }

    toggleMenu(e) {
        e.preventDefault();
        if (this.body.classList.contains('js-mobile-menu--visible')) {
            this.hideMenu(e);
        } else {
            this.showMenu(e);
        }
    }

    hideI18nMenuOptions() {
      const langs = ['en-EN'];
      for (let i = 0; i < langs.length; i++) {
        const lang = langs[i];
        const span = document.querySelector(`.language-dropdown__item-toggle-native[lang='${lang}']`);
        if (!span) {
          continue;
        }
        span.closest('.language-dropdown__item').classList.add('hidden');
      }
    }

    init() {
        if (!this.menuBtnToggle) return;
        this.menuBtnToggle.addEventListener('click', this.toggleMenu.bind(this));
        // this.menuBtnClose.addEventListener('click', this.hideMenu.bind(this));
        this.hideI18nMenuOptions();
    }
}
